module.exports = __webpack_public_path__ + "static/media/Edit-icon.a66414b3.svg";